import { gql } from '../../types/__codegen__/sanity';

export const GET_ALL_BANNER_QUERY = gql(`
  query banners {
    allBanner {
      _id
      name
      subtitle
      identifier {
        current
      }
      listItems {
        name
        identifier {
          current
        }
        ...InsurancePageListingFields
      }
    }
  }
`);
